<template>

  <div class="product-add">
    <el-alert title="温馨提醒" :closable='false' type="warning" description="渠道代理渠道代理渠道代理渠道代理渠道代理文字说明文字说明文字说明文字说明文字说明文字说明" show-icon>
    </el-alert>
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="180px">
      <!--添加门店-->
      <div class="common-form">总代理-渠道商抽成比例</div>
      <el-form-item label="总代理-渠道商抽成比例">
        <el-input v-model="form.channel_agent" placeholder="值(百分比)" class="max-w460"></el-input>%
      </el-form-item>
      <div class="common-form">渠道商抽成比例</div>
      <el-form-item label="渠道商抽成比例">
        <el-input v-model="form.channel_user" placeholder="值(百分比)" class="max-w460"></el-input>%
      </el-form-item>
      <div class="common-form">总代理-二级代理抽成比例</div>
      <el-form-item label="总代理-二级代理抽成比例">
        <el-input v-model="form.general_agency" placeholder="值(百分比)" class="max-w460"></el-input>%
      </el-form-item>
      <div class="common-form">二级代理抽成比例</div>
      <el-form-item label="二级代理抽成比例">
        <el-input v-model="form.secondary_agency" placeholder="值(百分比)" class="max-w460"></el-input>%
      </el-form-item>
      <div class="common-form">渠道端下载地址</div>

      <el-form-item label="渠道端下载地址" prop="name">
        <el-input v-model="form.download_url" placeholder="填写渠道端下载地址" class="max-w460"></el-input>
        <!-- <el-button @click="downloadClick" type="primary" size="small">点击下载</el-button> -->
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" :config="{ total: 3 }" @returnImgs="returnImgsFunc">
    </Upload>

  </div>

</template>

<script>
import ChannelApi from "@/api/channel.js";
import Upload from "@/components/file/Upload";
import { formatModel } from "@/utils/base.js";
export default {
  components: {
    Upload
  },
  data() {
    return {
      /*是否正在加载*/
      loading: false,
      /*form表单数据*/
      form: {
        channel_agent: "", //渠道总代理比例
        channel_user: "", //渠道用户比例
        general_agency: "", //总代理比例
        secondary_agency: "", //二级代理比例
        download_url: ""
      },
      /*是否打开图片选择*/
      isupload: false
    };
  },
  created() {
    this.getDate();
  },
  methods: {
    downloadClick(row) {
      // 创建一个下载链接
      const url = this.form.download_url;
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getDate() {
      ChannelApi.ChannelsetDetail({}, true)
        .then(res => {
          this.form = res.data.vars.values;
        })
        .catch(err => {});
    },
    onSubmit() {
      let self = this;
      let params = {};
      params = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          ChannelApi.Channelset(params, true)
            .then(res => {
              this.$message({
                message: res.msg,
                type: "success"
              });
            })
            .catch(err => {
              this.$message({
                message: err.msg,
                type: "warning"
              });
            });
        }
      });
    }
  }
};
</script>
<style>
.tips {
  color: #ccc;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/views/channel/setting/index.vue